import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./Header.scss";
import config from "config";
import { faPhone } from "@fortawesome/free-solid-svg-icons";

import { getInventoryAccessDetails } from "VENDOR/Actions/RoutingActions";
import ButtonLoader from "VENDOR/CommonResources/ButtonLoader/ButtonLoader";
const Header = (props) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [loader, setLoader] = useState(false);


  const toggleModal = () => {
    setIsModalOpen((prev) => !prev);
  };

  const handleViewProfile = () => {
    //alert("View Profile clicked!");
  };

  
  const userSignOut = () => {
    setLoader(true);
    const cookies = document.cookie.split(";");
  
    for (let cookie of cookies) {
      const eqPos = cookie.indexOf("=");
      const name = eqPos > -1 ? cookie.substr(0, eqPos).trim() : cookie.trim();
      document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/;domain=.vmedulife.com`;
    }
  
    for (let cookie of cookies) {
      const eqPos = cookie.indexOf("=");
      const name = eqPos > -1 ? cookie.substr(0, eqPos).trim() : cookie.trim();
      document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/;domain=stagevendor.vmedulife.com`;
    }
  
    setTimeout(() => {


      let url = "https://api.vmedulife.com";

      if(config.RootUrl == url){
        window.location.replace("http://login.vmedulife.com");

      }else{
        window.location.replace("http://stagelogin.vmedulife.com");
      }
      
    }, 100);
    setLoader(false);
  };

  return (
    <div className="header">
      <div className="left-section">
        <div className="logo">vmsoftware</div>
      </div>
    <div className="user-icon">
      <div  onClick={toggleModal}>
        <FontAwesomeIcon
          icon={["fas", "user-circle"]}
          size="lg"
          style={{ fontSize: 30, cursor: "pointer", marginRight:'10px'}}
          color="#fff"
        />
      </div>
      |
      <div className="user-signout" onClick={userSignOut}>
           
              <FontAwesomeIcon
                className="signout-icon icon"
                icon={["fas", "power-off"]}
                size="lg"
                style={{marginRight:'10px'}}
              />
              Sign Out {loader ? <ButtonLoader /> : ""}
            
          </div>
        </div>

      {/* User Modal */}
      {isModalOpen && (
        <div className="user-modal">
          <div className="modal-item" onClick={handleViewProfile}>
            <div className="userEmailId">
              {" "}
              <p style={{ fontSize: 14, fontWeight: "bold" }}>
              <FontAwesomeIcon
                  icon={["far", "user"]}
                  style={{ width: 20, fontSize: 18 }}
                />{" "}
                {config.instructorInfo.data.FirstName}{" "}
              </p>
              <p
                style={{
                  fontSize: 12,
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
                
                title={config.instructorInfo.data.EmailId}
              >
                <FontAwesomeIcon
                  icon={["far", "envelope"]}
                  style={{ width: 20, fontSize: 18 }}
                />{" "}
                {config.instructorInfo.data.EmailId}
              </p>
              <p
                style={{
                  fontSize: 12,
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
                
                title={config.instructorInfo.data.EmailId}
              >
                <FontAwesomeIcon
                  icon={["fas", "phone"]}
                  style={{ width: 20, fontSize: 18 }}
                />{" "}
                {config.instructorInfo.data.MobileNumber || "0000000000"}
              </p>
            </div>
          </div>
          
        </div>
      )}
    </div>
  );
};

export default Header;
